import { GameInfoService } from './service/GameInfoService'
import { gameInfoApi, mockGameInfoApi } from './api/gameInfoApi'

const api = import.meta.env.MODE === 'development' ? mockGameInfoApi : gameInfoApi
export const gameInfoService = new GameInfoService(api)
